<template>
  <div class="popup">
    <div class="card-holder">
      <div class="card">
        <div class="card-header" :class="headerClasses">
          <slot name="header"></slot>
        </div>
        <div class="card-body" :class="bodyClasses">
          <slot name="body"></slot>
        </div>
        <div class="card-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
    <div class="overlay" @click="close"></div>
  </div>
</template>

<script>

export default {
  name: 'PopupBase',

  props: {
    /**
     * Boolean to change header styles without box shadow, big padding etc.
     */
    inlineHeader: {
      type: Boolean,
      default: false,
    },

    /**
     * Set the same padding on the body as on the header
     */
    enableBodyPadding: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    close() {
      /**
       * Emit the close event
       */
      this.$emit('close');
    },
  },

  computed: {
    headerClasses() {
      return {
        'inline-header': this.inlineHeader,
      };
    },

    bodyClasses() {
      return {
        'padding': this.enableBodyPadding,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/sass/abstracts";

.popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto;

  .overlay {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}

.card-holder {
  width: 620px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  position: relative;
  z-index: 2;
  padding: 15px;
  overflow: auto;

  .card {
    background: $white;
    min-height: 10px;
    border-radius: $border-radius;

    .close {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 50%;
      right: 34px;
      transform: translateY(-50%);
      cursor: pointer;

      &:before,
      &:after {
        content: "";
        height: 2px;
        background: var(--c-popup-background);
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
        transform-origin: center;
      }

      &:before {
        transform: translateY(-50%) rotate(-45deg);
      }
    }

    .card-header {
      @include header-font;
      position: relative;
      font-size: 18px;
      background: var(--c-panel-heading-bg);
      color: var(--c-title-in-panel);
      padding: $card-padding;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.10);
      display: flex;
      align-items: center;
      border-top-left-radius: $border-radius;
      border-top-right-radius: $border-radius;

      &.inline-header {
        box-shadow: unset;
        padding: calc(#{$card-padding} / 2) $card-padding;
      }
    }

    .card-body {
      &.padding {
        padding: $card-padding;
      }

      .close {
        top: 32px;
      }
    }
  }
}
</style>
